'use client';

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface ActivityData {
  month: string;
  borrows: number;
  returns: number;
}

interface ActivityChartProps {
  data: ActivityData[];
}

export function ActivityChart({ data }: ActivityChartProps) {
  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorBorrows" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#64FFDA" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#64FFDA" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorReturns" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#3B82F6" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#1d3557" vertical={false} />
          <XAxis 
            dataKey="month" 
            stroke="#8892B0" 
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <YAxis 
            stroke="#8892B0" 
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#112240',
              border: '1px solid #1d3557',
              borderRadius: '8px',
              color: '#E6F1FF',
            }}
            itemStyle={{ color: '#E6F1FF' }}
            labelStyle={{ color: '#8892B0' }}
          />
          <Area
            type="monotone"
            dataKey="borrows"
            stroke="#64FFDA"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorBorrows)"
            name="借阅量"
          />
          <Area
            type="monotone"
            dataKey="returns"
            stroke="#3B82F6"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorReturns)"
            name="归还量"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
